import * as Sentry from "@sentry/react";
import { config } from "../config.ts";

Sentry.init({
  dsn: "https://b8ead6d46c5219dedfcc62e0744c76da@o4506400179945472.ingest.sentry.io/4506401498595328",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Performance Monitoring
  tracesSampleRate: config.env === "production" ? 0.1 : 1.0, //  Capture 100% of the transactions
  // // Session Replay
  // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  release: config.version,
  environment: config.env,
});
